import { isMock } from '../../config'
import { normalizeMiDniGuest } from './midni/midniQrData'
import type { MiDniExtractedData } from './midni/midniQrData'
import { midniQrCapture } from './midni/qrScanner'
import { createMockCapture, createMockQrCapture } from './mock'
import { createMobbscanCapture } from './real'
import type { DocumentCapture, DocumentReading, QrCapture, ReadContext } from './types'

/** Captura de documento del check-in: MobbScan real o simulada según VITE_MOCK_CHECKIN. */
export function createDocumentCapture(guestCode: string): DocumentCapture {
  return isMock('checkin') ? createMockCapture(guestCode) : createMobbscanCapture()
}

export function createQrCapture(guestCode: string): QrCapture {
  return isMock('checkin') ? createMockQrCapture(guestCode) : midniQrCapture
}

/** Lectura de MiDNI → parte de viajeros (sin fotos: MiDNI no las envía, como hoy). */
export async function readQr(data: MiDniExtractedData, ctx: ReadContext): Promise<DocumentReading> {
  const { guest, missingFields } = await normalizeMiDniGuest({ extractedData: data, currentGuest: ctx.current, stay: ctx.stay, getMunicipalities: ctx.getMunicipalities })
  return { guest, doubtful: missingFields, attachments: {}, rawData: data.rawData }
}

export { CaptureError } from './types'
export type { CaptureErrorCode, DocumentCapture, DocumentEvent, DocumentReading, FaceEvent, QrCapture, ReadContext, Side } from './types'
export type { MiDniExtractedData } from './midni/midniQrData'
